export class FeedbackAnswerValue {

    id:any;
	activeStatus:any;
	answerValue:any;
	fkFeedbackAnswerId:any;
}
